import React from "react";
import { connect } from "react-redux";


// import moment from "moment";
import campaignResultDefaultImg from '../../../assets/images/campaignResult-default.png'
import './extensionLogResult.css'
import LeftArrowImg from '../../../assets/images/left-arrow.png'
import RightArrowImg from '../../../assets/images/right-arrow.png'
import ShowJson from "../ShowJson";

export class ExtensionLogResult extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1,
            selectedLogData: null // To store the JSON data for ShowJson    
        }

    }


    getExtensionLogData = () => {

        let sortedArray = this.props.extensionLogs.slice(25 * this.state.currentPage - 25, 25 * this.state.currentPage)
        let JSX = [];

        sortedArray.forEach((entry) => {

            JSX.push(<tr className="ExtensionLogResult-value" key={entry.id}>
                <td className="ExtensionLogResult-date-value">{entry.InsertedOn.split('.')[0].replace('T', ' ')}</td>

                <td className="ExtensionLogResult-method-value">{entry.Action}</td>

                <td className="ExtensionLogResult-endpoint-value">{entry.DraftID}</td>
                <td>
                    <button className="show-params-button" onClick={() => {
                        let jsonData;
                        try {
                            jsonData = JSON.parse(entry.JSONResult); // Try parsing the JSON

                            jsonData=entry.JSONResult;
                        } catch (e) {
                            jsonData = JSON.stringify({ "message": "No Result Available" }); // Fallback if not valid JSON
                        }
                        this.setState({ selectedLogData: jsonData });
                    }}>
                        Show JSONResult
                    </button>
                </td>
                <td>
                    <button className="show-params-button" onClick={() => this.setState({ selectedLogData: entry.PValue === null ? JSON.stringify({ "value": "No params supplied" }) : entry.PValue })}>
                        Show Parameter Value
                    </button>
                </td>
                {/* <td className="ExtensionLogResult-responsecode-value">{entry.URL}</td> */}
            </tr>)
        })

        return JSX;

    }

    moveNextPage = () => {
        if (this.state.currentPage < this.props.maxPage) {
            this.setState({ currentPage: this.state.currentPage + 1 })
        }
    }
    movePreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 })
        }
    }

    conditionalRendering = () => {

        if (this.state.selectedLogData) {
            return (<ShowJson jsonData={this.state.selectedLogData} onClose={() => this.setState({ selectedLogData: null })} />);
        }
        if (this.props.extensionLogs) {
            return (<div className="ExtensionLogResult">

                <div className="ExtensionLogResult-log-details-container">
                    <table className="ExtensionLogResult-log-details">
                        <thead>
                            <tr>
                                <th className="ExtensionLogResult-date">Date</th>
                                <th className="ExtensionLogResult-method">Action</th>
                                <th className="ExtensionLogResult-endpoint">DraftID</th>
                                <th className="ExtensionLogResult-input">Result</th>
                                <th className="ExtensionLogResult-output">Parameter</th>
                                {/* <th className="ExtensionLogResult-responsecode">Url</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {this.getExtensionLogData(this.state.currentPage)}
                        </tbody>
                    </table>
                </div>
                <div className="ExtensionLogResult-pagination">
                    <div className="ExtensionLogResult-pagination-count">{this.state.currentPage} of {this.props.maxPage}</div>

                    <div className="ExtensionLogResult-pagination-buttongroup">
                        <button className="ExtensionLogResult-pagination-button-previous" onClick={this.movePreviousPage}>
                            <img src={LeftArrowImg} alt="Previous" ></img>
                        </button>
                        <button className="ExtensionLogResult-pagination-button-next" onClick={this.moveNextPage}>
                            <img src={RightArrowImg} alt="Next" ></img>
                        </button>
                    </div>
                </div>

            </div>)
        } else {
            return (<div className="CampaignResult-default">
                <img src={campaignResultDefaultImg} alt="Default" />
                <div> Let The Search Begin!</div>
            </div>)
        }
    }



    render() {
        return (
            <React.Fragment>
                {this.conditionalRendering()}
            </React.Fragment>

        )
    }
}

const mapStateToProps = (state) => {
    if (state.logs.extensionLogs.logs && state.logs.extensionLogs.logs.length) {
        //showing 25 entries max per page
        return { extensionLogs: state.logs.extensionLogs.logs, maxPage: state.logs.extensionLogs.logs.length % 25 === 0 ? state.logs.extensionLogs.logs.length / 25 : Math.ceil(state.logs.extensionLogs.logs.length / 25) };
    } else {
        return { extensionLogs: null, maxPage: 1 }
    }
};

export default connect(mapStateToProps)(ExtensionLogResult);
